import { useState } from 'react';
import { changePassword } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

const ForceChangePassword = () => {
  const { refreshUser } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    if (password !== confirm) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }
    setSubmitting(true);
    try {
      await changePassword(password);
      toast.success('Mot de passe modifié avec succès !');
      await refreshUser();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F6F9] flex items-center justify-center px-4" data-testid="force-change-password">
      <div className="bg-white rounded-2xl shadow-sm border border-[#BFC6CC]/20 p-8 max-w-md w-full">
        <div className="text-center mb-6">
          <img
            src="https://customer-assets.emergentagent.com/job_b5060da7-3cb1-4f34-ba83-21054a843fb3/artifacts/3oi7g9sb_pde2025.png"
            alt="Place des Energies"
            className="h-10 mx-auto mb-4"
          />
          <div className="w-14 h-14 bg-[#397DFF]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-7 h-7 text-[#397DFF]" />
          </div>
          <h1 className="text-xl font-bold text-[#191D1E] mb-2">Changement de mot de passe</h1>
          <p className="text-[#687175] text-sm">
            Pour la sécurité de votre compte, veuillez choisir un nouveau mot de passe.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-[#191D1E]">Nouveau mot de passe</Label>
            <div className="relative mt-1.5">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#F5F6F9] border-[#BFC6CC] text-[#191D1E] pr-10"
                placeholder="Minimum 6 caractères"
                required
                data-testid="new-password-input"
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#939BA0]">
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <div>
            <Label className="text-[#191D1E]">Confirmer le mot de passe</Label>
            <Input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="mt-1.5 bg-[#F5F6F9] border-[#BFC6CC] text-[#191D1E]"
              placeholder="Retapez votre mot de passe"
              required
              data-testid="confirm-password-input"
            />
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-[#397DFF] hover:bg-[#397DFF]/90 text-white py-6"
            data-testid="change-password-btn">
            {submitting ? 'Modification en cours...' : 'Valider mon nouveau mot de passe'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ForceChangePassword;
